/**
 * Butikkside (avdeling) - interne ankerlenker (hero-CTA, fakta-rad, "Se hele
 * utvalget" osv. som peker på #shop-landing-*-seksjoner på samme side).
 *
 * Nettleserens innebygde hopp-til-anker (vanlig <a href="#id">) endte opp på
 * feil sted på denne siden - bekreftet ved direkte testing på
 * lampemagasinet.no. Årsaken: siten setter `scroll-behavior: smooth`
 * globalt, og den animerte scrollen ble konsekvent avbrutt/forstyrret av noe
 * annet på siden før den nådde målet. Selv element.scrollIntoView({behavior:
 * "auto"}) hjelper ikke, fordi "auto" der betyr "følg CSS-ens
 * scroll-behavior" - fortsatt animert, fortsatt upålitelig. window.scrollTo
 * med behavior: "instant" er det eneste som faktisk overstyrer CSS-en.
 *
 * I tillegg: header-seksjonen har enable_sticky_header aktivert
 * (settings_data.json), og kan derfor dekke toppen av viewporten - samme
 * problem sections/finn-riktig-lampe.liquid allerede løser med en fast
 * -80px-justering. Her hentes header-høyden dynamisk i stedet, så det
 * fungerer likt uansett skjermstørrelse.
 */
(function () {
  "use strict";

  function getHeaderOffset() {
    var header = document.querySelector(".c-header-container");
    if (!header) return 80;
    var height = header.getBoundingClientRect().height;
    return height > 0 ? height + 12 : 80;
  }

  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href^="#shop-landing-"]');
    if (!link) return;
    var id = link.getAttribute("href").slice(1);
    var target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    var y = window.pageYOffset + target.getBoundingClientRect().top - getHeaderOffset();
    window.scrollTo({ top: Math.max(y, 0), left: 0, behavior: "instant" });
    if (window.history && window.history.pushState) {
      window.history.pushState(null, "", "#" + id);
    }
  });
})();

/**
 * Butikkside (avdeling) - "Populært hos oss".
 *
 * Sjekker en liste med bestselger-kandidater (levert som JSON av
 * sections/custom_shop-landing.liquid) mot det eksisterende lager-API-et
 * (samme endepunkt som produktsidens "Se lagerstatus i avdelinger" bruker),
 * ett produkt av gangen for denne butikkens shopId, og viser de første som
 * faktisk er på lager her - i bestselger-rekkefølge. Krever ingen manuell
 * oppdatering: kandidatlisten kommer fra en kolleksjon sortert "Bestselger"
 * i Shopify, og lagerstatus hentes live.
 *
 * CONCURRENCY er holdt lavt med vilje (lager-APIet har begrenset kapasitet).
 * Juster sammen med candidate_pool_size i seksjonens skjema om nødvendig.
 */
(function () {
  "use strict";

  var FETCH_URL = "https://lampemagasinet-app.vercel.app";
  var CONCURRENCY = 3;

  function fetchStock(shopId, sku) {
    var url = FETCH_URL + "/api/shopsStock?shops=" + encodeURIComponent(shopId) + "&sku=" + encodeURIComponent(sku);
    return fetch(url, { method: "GET" })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!Array.isArray(data)) return 0;
        var entry = data.find(function (d) {
          return String(d.shop) === String(shopId);
        });
        var stock = entry ? Number(entry.stock) : 0;
        return isNaN(stock) ? 0 : stock;
      })
      .catch(function () {
        return 0;
      });
  }

  function runWithConcurrency(items, limit, worker) {
    return new Promise(function (resolve) {
      var results = new Array(items.length);
      var next = 0;
      var remaining = items.length;

      if (remaining === 0) {
        resolve(results);
        return;
      }

      function startNext() {
        if (next >= items.length) return;
        var index = next++;
        worker(items[index], index)
          .then(function (result) {
            results[index] = result;
          })
          .catch(function () {
            results[index] = null;
          })
          .then(function () {
            remaining--;
            if (remaining === 0) {
              resolve(results);
            } else {
              startNext();
            }
          });
      }

      var starters = Math.min(limit, items.length);
      for (var i = 0; i < starters; i++) startNext();
    });
  }

  function buildCard(product) {
    var li = document.createElement("li");
    li.className = "shop-landing__product-item";

    var link = document.createElement("a");
    link.className = "shop-landing__product-link";
    link.href = product.url;

    var media = document.createElement("div");
    media.className = "shop-landing__product-media";

    // Bildet ligger i sin egen wrap med overflow:hidden (for avrundede
    // hjørner). Badgen ligger som søsken av wrap-en, IKKE inni den:
    // .u-absolute.u-top-0.u-left-0 har en egen "top/left: var(--pc-badge-
    // offset-*) !important"-regel (custom_products_cards_etc.css) som i
    // praksis flytter badgen litt utenfor - ment for kortet sin egen
    // padding/kant. Samme klassekombinasjon er også det pille-formen
    // (border-radius) på .c-badge-discount krever for å slå til, så vi må
    // beholde den - løsningen er å ikke klippe badgen, ikke å droppe klassene.
    var imageWrap = document.createElement("div");
    imageWrap.className = "shop-landing__product-image-wrap";
    if (product.image) {
      var img = document.createElement("img");
      img.src = product.image;
      img.alt = product.title || "";
      img.loading = "lazy";
      img.width = 400;
      img.height = 400;
      imageWrap.appendChild(img);
    }
    media.appendChild(imageWrap);

    if (product.badgeHtml) {
      var badgeWrap = document.createElement("div");
      badgeWrap.className = "u-absolute u-top-0 u-left-0";
      badgeWrap.innerHTML = product.badgeHtml;
      media.appendChild(badgeWrap);
    }

    var name = document.createElement("p");
    name.className = "shop-landing__product-name";
    name.textContent = product.title || "";

    // Priceteksten er server-rendret via snippets/price.liquid (samme kilde
    // som resten av siden) - ikke regnet ut på nytt her.
    var priceWrap = document.createElement("div");
    priceWrap.className = "shop-landing__product-price";
    priceWrap.innerHTML = product.priceHtml || "";

    link.appendChild(media);
    link.appendChild(name);
    link.appendChild(priceWrap);
    li.appendChild(link);
    return li;
  }

  function init(container) {
    if (container.dataset.shopLandingInitialized) return;
    container.dataset.shopLandingInitialized = "true";

    var dataEl = container.querySelector("[data-shop-landing-candidates]");
    var grid = container.querySelector("[data-shop-landing-grid]");
    var emptyMsg = container.querySelector("[data-shop-landing-empty]");
    var shopId = container.dataset.shopId;
    var wanted = parseInt(container.dataset.limit, 10) || 6;

    if (!dataEl || !grid) return;

    var candidates = [];
    try {
      candidates = JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      candidates = [];
    }

    if (!shopId || !candidates.length) {
      grid.innerHTML = "";
      if (emptyMsg) emptyMsg.hidden = false;
      container.classList.add("shop-landing__products--empty");
      return;
    }

    runWithConcurrency(candidates, CONCURRENCY, function (product) {
      return fetchStock(shopId, product.sku).then(function (stock) {
        return { product: product, stock: stock };
      });
    })
      .then(function (results) {
        var inStock = results
          .filter(function (r) {
            return r && r.stock > 0;
          })
          .slice(0, wanted);

        grid.innerHTML = "";

        if (!inStock.length) {
          if (emptyMsg) emptyMsg.hidden = false;
          container.classList.add("shop-landing__products--empty");
          return;
        }

        inStock.forEach(function (r) {
          grid.appendChild(buildCard(r.product));
        });
      })
      .catch(function () {
        grid.innerHTML = "";
        if (emptyMsg) emptyMsg.hidden = false;
      });
  }

  // Loaded with `defer`, so the DOM is already fully parsed by the time this runs.
  document.querySelectorAll("[data-shop-landing-products]").forEach(init);
})();

/**
 * Butikkside (avdeling) - 3D "coverflow"-karusell for hero-bildene.
 * Rene CSS-transforms (translateX/translateZ/rotateY/scale) + CSS-transitions
 * gjør selve bevegelsen; dette scriptet holder bare styr på hvilket bilde som
 * er aktivt og oppdaterer et data-pos-attributt ("-1" | "0" | "1" | "hidden")
 * per kort, i tillegg til klikk/dra/swipe/autoplay.
 */
(function () {
  "use strict";

  var AUTOPLAY_MS = 4500;
  var DRAG_THRESHOLD = 40;
  var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initCoverflow(container) {
    if (container.dataset.coverflowInitialized) return;
    container.dataset.coverflowInitialized = "true";

    var cards = Array.prototype.slice.call(container.querySelectorAll("[data-coverflow-card]"));
    var count = cards.length;
    if (count < 2) return;

    var activeIndex = 0;
    var autoplayTimer = null;
    var hovering = false;
    var dragging = false;
    var dragged = false;
    var activePointerId = null;
    var startX = 0;
    var currentX = 0;

    function render() {
      cards.forEach(function (card, i) {
        var diff = i - activeIndex;
        diff = ((diff % count) + count) % count;
        if (diff > count / 2) diff -= count;

        var pos;
        if (diff === 0) pos = "0";
        else if (diff === 1) pos = "1";
        else if (diff === -1) pos = "-1";
        else pos = "hidden";

        card.setAttribute("data-pos", pos);
        card.setAttribute("aria-current", pos === "0" ? "true" : "false");
        card.tabIndex = pos === "hidden" ? -1 : 0;
      });
    }

    function goTo(index) {
      activeIndex = ((index % count) + count) % count;
      render();
    }

    function next() {
      goTo(activeIndex + 1);
    }

    function prev() {
      goTo(activeIndex - 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (prefersReducedMotion || hovering) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, AUTOPLAY_MS);
    }

    cards.forEach(function (card, i) {
      card.addEventListener("click", function () {
        if (dragged) return;
        goTo(i);
      });
    });

    container.addEventListener("pointerenter", function (e) {
      if (e.pointerType !== "mouse") return;
      hovering = true;
      stopAutoplay();
    });
    container.addEventListener("pointerleave", function (e) {
      if (e.pointerType !== "mouse") return;
      hovering = false;
      startAutoplay();
    });

    container.addEventListener("pointerdown", function (e) {
      if (dragging) return;
      dragging = true;
      dragged = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      currentX = e.clientX;
      stopAutoplay();
      try {
        container.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    container.addEventListener("pointermove", function (e) {
      if (!dragging || e.pointerId !== activePointerId) return;
      currentX = e.clientX;
      if (Math.abs(currentX - startX) > 8) dragged = true;
    });
    container.addEventListener("pointerup", function (e) {
      if (!dragging || e.pointerId !== activePointerId) return;
      dragging = false;
      activePointerId = null;
      var delta = currentX - startX;
      if (dragged) {
        if (delta < -DRAG_THRESHOLD) next();
        else if (delta > DRAG_THRESHOLD) prev();
      }
      setTimeout(function () {
        dragged = false;
        startAutoplay();
      }, 50);
    });
    container.addEventListener("pointercancel", function (e) {
      if (e.pointerId !== activePointerId) return;
      dragging = false;
      dragged = false;
      activePointerId = null;
      startAutoplay();
    });

    render();
    startAutoplay();
  }

  document.querySelectorAll("[data-coverflow]").forEach(initCoverflow);
})();